import moment from "moment-timezone";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { Coupons } from "../../controller/StoreController";
import { langState, langText } from "../../recoil/lang";
import { visibleCouponListState } from "../../recoil/modal";
import "../../styles/CustomModal.css";

type Props = {
  coupons: Coupons[];
  modalType: string;
  resetTimer: any;
};

const CouponListModal = ({ coupons, modalType, resetTimer }: Props) => {
  const [isVisible, setVisible] = useRecoilState<boolean>(
    visibleCouponListState
  );
  const lang = useRecoilValue<number>(langState);

  const onCloseModal = () => {
    setVisible(false);
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "couponListModalOverlay",
        modal: "couponListModal",
      }}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="닫기버튼"
          className="closeButton"
        />
      }
    >
      <Style>
        <div
          className="couponListModalWrap"
          onTouchStart={resetTimer}
          onScrollCapture={resetTimer}
        >
          <h2>{langText.coupon_modal_title[lang]}</h2>
          <h3>{langText.coupon_modal_sub_title[lang]}</h3>
          <div className="couponListWrap">
            {coupons &&
              coupons.map((data, index) => (
                <div
                  key={index}
                  className={`couponListContent ${
                    modalType === "main" && "mainColor"
                  }`}
                >
                  {data.coupon_type === 0 ? (
                    <h1>{data.price.toLocaleString()}원</h1>
                  ) : (
                    <h1>{data.percent}%</h1>
                  )}

                  <p>{data.coupon_name}</p>

                  <p>
                    {data.requirement.toLocaleString()}원
                    {langText.min_price_notice[lang]}
                  </p>
                  {data.coupon_type === 1 && (
                    <p>
                      {langText.optionModal_title_Maximum[lang]}{" "}
                      {data.max_discount.toLocaleString()}원{" "}
                      {langText.discount[lang]}
                    </p>
                  )}
                  {modalType === "main" && (
                    <p>
                      사용기간 :
                      {data.end_date &&
                        moment(data.end_date).format("YYYY-MM-DD HH:mm:ss")}
                    </p>
                  )}
                </div>
              ))}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CouponListModal;

const Style = styled.div`
  * {
    color: #fff;
  }
  h2 {
    font-size: 32px;
    font-weight: 700;
  }
  h3 {
    margin: 40px 0;
    padding: 0 40px;
    font-size: 18px;
    font-weight: 400;
  }

  .closeButton {
    width: 44px;
    height: 44px;
  }

  /* couponListModalWrap */
  .couponListModalWrap {
    max-height: 100vh;
    min-height: 100vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
  }

  /* couponListWrap */
  .couponListWrap {
    max-height: 800px;
    overflow-y: auto;
  }
  /* couponListContent */
  .couponListContent {
    width: 85vw;
    margin-bottom: 20px;
    padding: 42px 55px;
    text-align: left;
    border-radius: 20px;
    background: #ffb800;

    h1 {
      padding-bottom: 18px;
      font-size: 40px;
      font-weight: 700;
    }
    p {
      margin-top: 10px;
      margin-bottom: 0px;
      font-size: 18px;
      font-weight: 400;
    }
  }
  .couponListContent.mainColor {
    background: #4dd2ae;
  }
`;
